import { Link } from "react-router-dom";
import { ArrowRight, MapPin, BedDouble, Ticket } from "lucide-react";
import { Reveal } from "../lib/motion";
import { GuidePrice } from "./GuidePrice";

export function BreakCard({ brk, index = 0 }) {
  return (
    <Reveal delay={index * 0.08} className="h-full">
      <article className="group flex h-full flex-col" data-testid={`break-card-${brk.slug}`}>
        <Link to={`/breaks/${brk.slug}`} className="relative block overflow-hidden rounded-lg" tabIndex={-1} aria-hidden="true">
          <div className="aspect-[16/11] overflow-hidden rounded-lg">
            <img
              src={brk.card_image}
              alt={brk.name}
              loading="lazy"
              className="h-full w-full object-cover transition-transform duration-[1.2s] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.07]"
            />
          </div>
          {/* spotlight veil */}
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
          <span className="absolute left-4 top-4 font-serif text-lg italic text-sand/90" style={{ textShadow: "0 1px 8px rgba(0,0,0,0.5)" }}>
            № {String(index + 1).padStart(2, "0")}
          </span>
          <div className="absolute right-4 top-4 flex flex-col gap-2">
            {brk.is_new && <span className="rounded-full bg-accent px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-white">New</span>}
            {brk.popular && <span className="rounded-full bg-primary px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-sand">Popular</span>}
          </div>
        </Link>
        <div className="flex flex-1 flex-col pt-5">
          <p className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.15em] text-ink-muted">
            <MapPin className="h-3.5 w-3.5" /> {brk.destination_name}
          </p>
          <h3 className="mt-2 text-2xl font-semibold leading-snug text-ink">
            <Link to={`/breaks/${brk.slug}`} className="transition-colors duration-300 hover:text-primary" data-testid={`break-card-link-${brk.slug}`}>
              {brk.name}
            </Link>
          </h3>
          <p className="mt-1 font-serif text-lg italic text-ink-muted">{brk.tagline}</p>
          <div className="mt-4 flex flex-wrap gap-x-5 gap-y-1 text-sm text-ink-muted">
            <span className="inline-flex items-center gap-1.5"><BedDouble className="h-4 w-4" /> {brk.nights} night{brk.nights > 1 ? "s" : ""} B&amp;B</span>
            <span className="inline-flex items-center gap-1.5"><Ticket className="h-4 w-4" /> {brk.experiences_count} experiences included</span>
          </div>
          <div className="mt-5 flex flex-1 items-end justify-between gap-3 border-t border-sandline pt-4">
            <GuidePrice brk={brk} />
            <Link to={`/breaks/${brk.slug}`} className="link-sweep inline-flex items-center gap-1.5 text-sm font-semibold text-primary" data-testid={`view-break-${brk.slug}`}>
              View break <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      </article>
    </Reveal>
  );
}
